// extracted by mini-css-extract-plugin
export default {"main":"_96a7cb2659 _0ca3aabbab _8749435546 _1aedaadcea","title":"_07dbb31f77"};